import type { AppStore } from "@/Modules/App/Store";
import type { ChoicesTransformerType } from "@/Modules/Transformers/Choices";

import ChoicesApiConnector from "@/Services/TherapyApi/Choices";

import ChoicesTransformer from "@/Modules/Transformers/Choices";

import { log } from "@/Utils/Debug";

class GetChoicesActionHandler {
  constructor(
    private readonly appStore: AppStore,
    private readonly choicesApiConnector: ChoicesApiConnector = new ChoicesApiConnector(),
    private readonly choicesTransformer: ChoicesTransformerType = ChoicesTransformer
  ) {}

  public handle() {
    this.appStore.isLoading = true;

    this.choicesApiConnector
      .getChoices("cancel_reason_choices")
      .then((res) => {
        this.appStore.cancelReasons = this.choicesTransformer.toDomain(res);
      })
      .catch(log)
      .finally(() => {
        this.appStore.isLoading = false;
      });
  }
}

export default GetChoicesActionHandler;
